import { render, staticRenderFns } from "./ServerBasedPms.vue?vue&type=template&id=15837190&scoped=true&"
import script from "./ServerBasedPms.vue?vue&type=script&lang=js&"
export * from "./ServerBasedPms.vue?vue&type=script&lang=js&"
import style0 from "./ServerBasedPms.vue?vue&type=style&index=0&id=15837190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15837190",
  null
  
)

export default component.exports